import { useHistory } from "react-router";
import { useLocation } from "core/shared/hooks/useStableRouter";
import { useMemo } from "react";

const useSmartLinkHistory = () => {
  const location = useLocation();
  const history = useHistory();
  const { pathname, search } = location;

  return useMemo(
    () => ({
      push: (path, state) =>
        history.push(pathname + path + search, { ...state }),
      pop: (path, state) => {
        if (path !== pathname) history.push(path + search, { ...state });
      },
      popWithSearch: ({ path, searchQuery }) => {
        if (path !== pathname) history.push(path + searchQuery);
      },
      replace: (path, state) => {
        history.replace(path + search, state);
      },
    }),
    [history, pathname, search]
  );
};

export default useSmartLinkHistory;
